import axios from 'axios';

import { CONFIG } from '../config-global';

// ----------------------------------------------------------------------

const axiosInstance = axios.create({ baseURL: CONFIG.site.serverUrl });

axiosInstance.interceptors.response.use(
  (response) => response,
  (error) => Promise.reject((error.response && error.response.data) || 'Something went wrong!')
);

export default axiosInstance;

// ----------------------------------------------------------------------

export const fetcher = async (args) => {
  try {
    const [url, config] = Array.isArray(args) ? args : [args];

    const res = await axiosInstance.get(url, { ...config });

    return res.data;
  } catch (error) {
    console.error('Failed to fetch:', error);
    throw error;
  }
};

// ----------------------------------------------------------------------

const baseURL = "https://api.instajet.bluejungle.org"

export const endpoints = {
  auth: {
    me: `${baseURL}/auth/me`,
    signIn: `${baseURL}/auth/login`,
    signUp: `${baseURL}/auth/register`,
  },
  upload: `${baseURL}/upload`,
  automations: {
    automations: `${baseURL}/automations`,
    automation: (id) => `${baseURL}/automations/${id}`,
    automationTest: (id) => `${baseURL}/automations/test/${id}`,
  },
  meta: {
    logoutFacebook: `${baseURL}/facebook/logout`,
    deleteDataFacebook: `${baseURL}/facebook/delete-data`,
    connectFacebook: `${baseURL}/facebook/connect`,
    loginFacebook: `${baseURL}/facebook/login-init`,
    callbackFacebook: `${baseURL}/facebook/callback`,
    pagesFacebook: `${baseURL}/facebook/pages`,
    subscribeFacebook: (pageId) => `${baseURL}/facebook/pages/${pageId}/subscribe`,
    webhook: `${baseURL}/webhook`,
  },
  instagram: {
    accounts: `${baseURL}/instagram/accounts`,
    conversations: `${baseURL}/instagram/conversations`,
    conversationMesseges: (conversationId) => `${baseURL}/instagram/messeges/${conversationId}`,
    sendMesseges: `${baseURL}/instagram/messeges/send`,
    streamMesseges: `${baseURL}/instagram/messeges/stream`,
    media: `${baseURL}/instagram/media`,
    mediaById: (id)=>`${baseURL}/instagram/media/${id}`,
  },
  mail: {
    list: `${baseURL}/api/mail/list`,
    details: `${baseURL}/api/mail/details`,
    labels: `${baseURL}/api/mail/labels`,
  },
  post: {
    list: `${baseURL}/api/post/list`,
    details: `${baseURL}/api/post/details`,
    latest: `${baseURL}/api/post/latest`,
    search: `${baseURL}/api/post/search`,
  },
  product: {
    list: `${baseURL}/api/product/list`,
    details: `${baseURL}/api/product/details`,
    search: `${baseURL}/api/product/search`,
  },
};
